import React, { useState } from "react";
import { Box, Stack } from "@mui/material";
import MarketPlaceSideBar from "./MarketPlaceSideBar";
import MarketPlaceViewList from "./Index";

const classes = {
  chatBox1: {
    minWidth: "26%",
    maxWidth: "26%",
    backgroundColor: "#F9F8F8",
    height: "calc(100vh - 4rem)",
    overflow: "hidden",
    "@media (max-width: 1194px)": {
      height: "69vh",
    },
  },
  chatComponent: {
    height: "calc(100vh - 4rem)",
    overflow: "hidden",
    "@media (max-width: 1194px)": {
      height: "69%",
    },
  },
};

const ArkchatNetwork = () => {
  const [isSellerTabLoading, setSellerTabLoading] = useState(false);
  const [isSideBarOpen, setSideBarOpen] = useState(false);
  const [networkTabValue, setNetworkTabValue] = useState(0);

  return (
    <Box height={"100%"} overflow={"hidden"}>
      <Stack height={"100%"} direction="row" spacing={0}>
        {isSideBarOpen && (
          <Box sx={classes.chatBox1}>
            <MarketPlaceSideBar
              setSideBarOpen={setSideBarOpen}
              setSellerTabLoading={setSellerTabLoading}
              isSellerTabLoading={isSellerTabLoading}
              networkTabValue={networkTabValue}
            />
          </Box>
        )}
        <Box
          sx={classes.chatComponent}
          flex={5.2}
        >
          <MarketPlaceViewList
            setSellerTabLoading={setSellerTabLoading}
            isSellerTabLoading={isSellerTabLoading}
            isSideBarOpen={isSideBarOpen}
            setSideBarOpen={setSideBarOpen}
            networkTabValue={networkTabValue}
            setNetworkTabValue={setNetworkTabValue}
          />
        </Box>
      </Stack>
    </Box>
  );
};

export default ArkchatNetwork;
